<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH BÀI VIẾT</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              icon="el-icon-circle-plus-outline"
              >thêm mới bài viết</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Tiêu đề">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['tieu_de']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Thời điểm tạo">
                        <el-date-picker
                          v-model="
                            mData.tableRules.dataSearch.value['thoi_diem_tao']
                          "
                          type="daterange"
                          range-separator="-"
                          format="dd/MM/yyyy"
                          start-placeholder="Từ ngày"
                          end-placeholder="Đến ngày"
                          size="medium"
                          @input="$forceUpdate()"
                          style="width: 100%"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="tieu_de"
                label="Tiêu đề"
                min-width="200"
              ></el-table-column>
              <el-table-column
                prop="mo_ta_ngan_gon"
                label="Mô tả ngắn gọn"
                min-width="250"
              ></el-table-column>

              <el-table-column
                prop="thoi_diem_tao"
                align="center"
                label="Thời điểm tạo"
                width="140"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      fn_formatDate(scope.row.thoi_diem_tao),
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="thu_tu"
                label="Thứ tự"
                align="center"
                width="100"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column>
              <el-table-column label="Hiển thị" width="80" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.hien_thi"
                    @change="fn_hienThiBaiViet(scope.row, scope.row.hien_thi)"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" align="center" width="150px">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormBaiViet";
import mushroom from "viettoc-api";
import moment from "moment";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      aElement: MethodService.element,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields:
          "id,thu_tu,uu_tien,tieu_de,mo_ta_ngan_gon,anh_id,noi_dung,tags,bai_viet_ids,hien_thi,thoi_diem_tao,but_danh,nguoi_tao_id",
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachBaiViet",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }
      try {
        const response = await mushroom.ldp_bai_viet.listAsync(dataFilter);
        if (response.result) {
          console.log("ds bài viết:", response.result);
          this.mData.tableRules.data = response.result;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
          this.loading = false;
        }
      } catch (e) {
        this.loading = false;
        MethodService.showError(e.code);
      }
    },
    fn_tableSortChange(column, tableRules) {
      tableRules = this.mData.tableRules;
      MethodService.tableSortChange(column, tableRules);
      this.fn_initTable();
    },

    fn_formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    // tạo bài viết
    fn_add() {
      this.$router.push({
        name: "TaoBaiViet",
      });
    },

    // cập nhật trạng thái hiển thị/ẩn bài viết
    async fn_hienThiBaiViet(row) {
      const bai_viet_object = {
        id: row.id,
        hien_thi: row.hien_thi,
      };
      try {
        const response = await mushroom.ldp_bai_viet.partialUpdateAsync(
          bai_viet_object
        );
        response.result == bai_viet_object.id
          ? window.toastr.success("Cập nhật hiển thị bài viết thành công")
          : window.toastr.warning("Dữ liệu không thay đổi");
      } catch (e) {
        this.loading = false;
        MethodService.showError(e.code);
      }
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "update") {
        this.$router.push({
          name: "CapNhatBaiViet",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "BaiVietChiTiet",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch((e) => {
            MethodService.showError(e.code);
          });
      }
    },
    async fn_delete(id) {
      try {
        await mushroom.ldp_bai_viet.deleteAsync({ id: id });
        window.toastr.success("Xóa bài viết thành công");
      } catch (e) {
        MethodService.showError(e.code);
      }
      this.fn_initTable();
    },

    fn_hashUrl(routeQuery, tableRules) {
      routeQuery = this.$route.query;
      tableRules = this.mData.tableRules;
      MethodService.hashUrl(routeQuery, tableRules);
    },
    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      this.$router.replace({
        name: "DanhSachBaiViet",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable();
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["tieu_de"]) {
        this.mData.tableRules.dataSearch.value["tieu_de"] =
          this.mData.tableRules.dataSearch.value["tieu_de"].trim();
      }

      this.loading = true;
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.mData.tableRules.offset = 0;
      this.fn_initTable();
      MethodService.stopLadda();
    },
  },
  //run after render view
  async created() {
    this.fn_hashUrl();
    await this.fn_initTable();
  },
};
</script>
<style scoped>
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}

@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
